export const isArray = function (array: any) {
  return Array.isArray(array)
}

export const isObject = function (obj: any) {
	return obj === Object(obj) && !isArray(obj) && typeof obj !== 'function'
}

export const snakeToCamel = (str: string) => str.replace(/(_\w)/g, k => k[1].toUpperCase())

export const keysToCamel = function (val: any) {
  if (isObject(val)) {
    const n: {[name: string]: unknown} = {}

    Object.keys(val)
      .forEach((key) => {
        n[snakeToCamel(key as string)] = keysToCamel(val[key])
      })

    return n
  } else if (isArray(val)) {
    return val.map((index: any) => {
      return keysToCamel(index)
    })
  }

  return val
}
